import React from 'react'
import { Tag as TagAnt } from 'antd'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'src/store'
import {
  RequestTicketSelectedSituation,
  RequestTicketTitleAdvanceSituation
} from 'src/types'
import { T } from 'src/components/atoms'

interface Props {
  status: Status
}

type Status =
  | RequestTicketSelectedSituation
  | RequestTicketTitleAdvanceSituation

function getStatusColor(status: Status) {
  switch (status) {
    case 'ACTIVE':
    case 'APPROVING':
      return 'blue'
    case 'APPROVED':
    case 'QUOTATION':
    case 'RESERVED':
      return 'geekblue'
    case 'CANCELED':
    case 'EMISSION_CANCELED':
    case 'EXPIRED':
      return 'red'
    case 'WAITING_RESERVATION':
    case 'WAITING':
      return 'orange'
    case 'ISSUED':
      return 'green'
  }
}

function TagTicketSituation({ status }: Props) {
  const {
    me: {
      user: { tenant_id }
    }
  } = useSelector((state: ApplicationState) => ({
    me: state.me
  }))
  const forceStatusToEmmited =
    +tenant_id === 559042084949 && status === 'WAITING_RESERVATION'
  const newStatus = forceStatusToEmmited ? 'ISSUED' : status
  return (
    <TagAnt color={getStatusColor(status)}>
      <T text={`common.status.ticket-situation.${newStatus}`.toLowerCase()} />
    </TagAnt>
  )
}

export default TagTicketSituation
